import { MessageSquare } from 'lucide-react';

function NoProductFound() {
  return (
    <div className="text-center text-muted my-4">
      <MessageSquare size={28} className="mb-2" />
      <p className="mb-0">No product reviews available yet.</p>
    </div>
  );
}

export default NoProductFound;
